// extracted by mini-css-extract-plugin
module.exports = {"tableList__table":"l_bg","tableList":"l_bh","tableList__key":"l_bj","tableList__value":"l_bk","tableList_isHidden":"l_bl"};